import { TJsonQuery } from '../../../../packages/JsonQuery';

export function getJsonQueryWithoutRequestOnlyTerms(jsonQuery: TJsonQuery): TJsonQuery {
  const jsonQueryWithoutRequestOnlyTerms = { ...jsonQuery };

  delete jsonQueryWithoutRequestOnlyTerms.ids;
  delete jsonQueryWithoutRequestOnlyTerms.page;

  return jsonQueryWithoutRequestOnlyTerms as TJsonQuery;
}
